<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="queueInfo" (ngSubmit)="handleSave()">
    <div class="enhanced-edit-container" onsip-grid-placement-shelf>
      <div class="first-column">
        <section>
          <mat-checkbox color="primary" formControlName="queueReporting">
            <mat-label class="mat-body-1"
              >Enable queue reporting
              <mat-icon
                [matTooltip]="
                  'Enables reporting of realtime caller/agent events and aggregated statistics.'
                "
                matTooltipClass="onsip-tooltip-background"
                [matTooltipPosition]="'above'"
                class="tool-tip-icon"
                >help_outline
              </mat-icon>
            </mat-label>
          </mat-checkbox>
          <mat-checkbox color="primary" formControlName="callRecording">
            <mat-label class="mat-body-1"
              >Enable call recording
              <mat-icon
                [matTooltip]="
                  'Records all calls in a queue and saves them to an external storage service.'
                "
                matTooltipClass="onsip-tooltip-background"
                [matTooltipPosition]="'above'"
                class="tool-tip-icon"
                >help_outline
              </mat-icon>
            </mat-label>
          </mat-checkbox>
        </section>
        @if (queueInfo.controls.callRecording.value) {
        <section class="with-mat-form-field property storage-prop-flex">
          <div class="mat-body-1 property-header">Storage service</div>
          <mat-form-field
            appearance="outline"
            onsip-form-field-flush-outline
            onsip-hide-subscript-wrapper
          >
            <mat-select formControlName="storageService">
              @for (service of storageServices; track service) {
              <mat-option [value]="service">
                {{ service.name }}
              </mat-option>
              }
            </mat-select>
            <mat-error>{{
              getGenericRequiredError(queueInfo.controls.storageService, "Storage service")
            }}</mat-error>
          </mat-form-field>
          <button
            class="add-storage-btn"
            color="primary"
            type="button"
            mat-button
            (click)="addStorageService()"
          >
            <mat-icon>add</mat-icon>
            <span>Add storage service</span>
          </button>
        </section>
        } @if (queueInfo.controls.callRecording.value) {
        <section class="property recording-announcement-prop">
          <div class="mat-body-1 property-header">Recording Announcement</div>
          <mat-radio-group
            color="primary"
            formControlName="recordingAnnouncement"
            class="recording-announcement-radio-group"
          >
            <mat-radio-button [value]="" onsip-mat-radio-button-label-align-normal>
              None
            </mat-radio-button>
            <mat-radio-button [value]="'basic'" onsip-mat-radio-button-label-align-normal>
              Your call may be recorded.
            </mat-radio-button>
            <mat-radio-button [value]="'training'" onsip-mat-radio-button-label-align-normal>
              Your call may be recorded for quality assurance and training purposes.
            </mat-radio-button>
            <mat-radio-button [value]="'monitored'" onsip-mat-radio-button-label-align-normal>
              Your call may be monitored or recorded for quality assurance.
            </mat-radio-button>
          </mat-radio-group>
        </section>
        } @if (queueInfo.controls.callRecording.value) {
        <section class="property">
          <div class="mat-body-1 property-header">Recording tone</div>
          <mat-checkbox
            color="primary"
            formControlName="recordingTone"
            onsip-checkbox-label-align-normal
          >
            <mat-label class="recording-tone-label mat-body-1"
              >Play a tone periodically during call recording</mat-label
            >
          </mat-checkbox>
        </section>
        }
      </div>
      <div class="second-edit-column" formGroupName="emailValues">
        @if (queueInfo.controls.queueReporting.value) {
        <section class="property">
          <div class="mat-body-1 property-header email-reports-header">Email reports</div>
          @if (existingEmailCount > 0) {
          <div>
            @for (emailFreq of existingEmailHashValues; track emailFreq) {
            <div>
              <div class="email-entry-fields existing-email-fields">
                <mat-form-field
                  appearance="outline"
                  onsip-form-field-flush-outline
                  class="email-report-field"
                >
                  <mat-select [formControlName]="emailFreq[0]">
                    @for (freq of reportFrequencies; track freq) {
                    <mat-option [value]="freq">
                      {{ freq }}
                    </mat-option>
                    }
                  </mat-select>
                  <mat-error>{{
                    getGenericRequiredError(emailValuesForm.controls[emailFreq[0]], "Frequency")
                  }}</mat-error>
                </mat-form-field>
                <div class="mat-body-1 property-header email-reports-header">
                  {{ "ONSIP_I18N.EMAIL_ADDRESS" | translate }}
                </div>
                <span class="email-freq-delete-flex">
                  <mat-form-field appearance="outline" class="text-field email-report-field">
                    <input
                      matInput
                      required
                      [formControlName]="emailFreq[1]"
                      autocomplete="off"
                      [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_EDIT_SHELVE_ENHANCED_EMAIL"
                    />
                    <mat-error>{{
                      getGenericRequiredError(emailValuesForm.controls[emailFreq[1]], "Email")
                    }}</mat-error>
                  </mat-form-field>
                  @if (+emailFreq[0].charAt(emailFreq[0].length - 1) > 0) {
                  <div>
                    @if (!isMobile) {
                    <button
                      mat-icon-button
                      (click)="
                        removeEmail(+emailFreq[0].charAt(emailFreq[0].length - 1), 'existing');
                        $event.stopPropagation()
                      "
                      class="delete-button"
                      color="primary"
                      type="button"
                    >
                      <mat-icon class="delete-icon">delete</mat-icon>
                    </button>
                    } @if (isMobile) {
                    <button
                      mat-stroked-button
                      (click)="
                        removeEmail(+emailFreq[0].charAt(emailFreq[0].length - 1), 'existing');
                        $event.stopPropagation()
                      "
                      class="remove-button"
                      color="primary"
                      type="button"
                    >
                      Remove
                    </button>
                    }
                  </div>
                  }
                </span>
              </div>
            </div>
            }
          </div>
          }
          <div>
            @for (emailFreq of additionalEmailHashValues; track emailFreq) {
            <div>
              <div class="email-entry-fields additional-email-fields">
                <mat-form-field
                  appearance="outline"
                  onsip-form-field-flush-outline
                  class="email-report-field"
                >
                  <mat-select [formControlName]="emailFreq[0]">
                    @for (freq of reportFrequencies; track freq) {
                    <mat-option [value]="freq">
                      {{ freq }}
                    </mat-option>
                    }
                  </mat-select>
                  <mat-error>{{
                    getGenericRequiredError(emailValuesForm.controls[emailFreq[0]], "Frequency")
                  }}</mat-error>
                </mat-form-field>
                <div class="mat-body-1 property-header email-reports-header">
                  {{ "ONSIP_I18N.EMAIL_ADDRESS" | translate }}
                </div>
                <span class="email-freq-delete-flex">
                  <mat-form-field appearance="outline" class="text-field email-report-field">
                    <input
                      matInput
                      required
                      [formControlName]="emailFreq[1]"
                      autocomplete="off"
                      [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_EDIT_SHELVE_ENHANCED_EMAIL"
                    />
                    <mat-error>{{
                      getGenericRequiredError(emailValuesForm.controls[emailFreq[1]], "Email")
                    }}</mat-error>
                  </mat-form-field>
                  @if ( existingEmailHashValues.length > 0 ||
                  +emailFreq[0].charAt(emailFreq[0].length - 1) > 0 ) {
                  <div>
                    @if (!isMobile) {
                    <button
                      mat-icon-button
                      (click)="
                        removeEmail(+emailFreq[0].charAt(emailFreq[0].length - 1), 'additional');
                        $event.stopPropagation()
                      "
                      color="primary"
                      type="button"
                      class="delete-button"
                    >
                      <mat-icon class="delete-icon">delete</mat-icon>
                    </button>
                    } @if (isMobile) {
                    <button
                      mat-stroked-button
                      (click)="
                        removeEmail(+emailFreq[0].charAt(emailFreq[0].length - 1), 'additional');
                        $event.stopPropagation()
                      "
                      class="remove-button"
                      color="primary"
                      type="button"
                    >
                      Remove
                    </button>
                    }
                  </div>
                  }
                </span>
              </div>
            </div>
            }
          </div>
          @if (existingEmailHashValues.length + additionalEmailHashValues.length < 7) {
          <div>
            <button
              class="add-email-btn"
              color="primary"
              type="button"
              mat-button
              (click)="addEmail()"
            >
              <mat-icon>add</mat-icon>
              <span>Add another email</span>
            </button>
          </div>
          }
        </section>
        }
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
      <button
        class="submit-button"
        type="submit"
        mat-flat-button
        color="primary"
        [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_EDIT_SHELVE_EDIT_BUTTON"
      >
        Save changes
      </button>
    </div>
  </form>
</onsip-loading-container>
